import { Dialog, ImagePreview } from 'vant';
import { session, local } from "./session";

// 课程时长（视频，音频，直播时长）
export function formatSeconds(courseType, duration) { // 类型，时长
  // console.log(courseType, duration);
  duration= !duration ? 0 : duration;
  if(courseType==='VIDEO' || courseType==='AUDIO'){
    // item.duration
    let secondTime = parseInt(duration);// 秒
    let minuteTime = 0;// 分
    let hourTime = 0;// 小时
    if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
      minuteTime = parseInt(secondTime / 60);//获取分钟，除以60取整数，得到整数分钟
      secondTime = parseInt(secondTime % 60);//获取秒数，秒数取佘，得到整数秒数
      if (minuteTime > 60) {//如果分钟大于60，将分钟转换成小时
        hourTime = parseInt(minuteTime / 60);//获取小时，获取分钟除以60，得到整数小时
        minuteTime = parseInt(minuteTime % 60);//获取小时后取佘的分，获取分钟除以60取佘的分
      }
    }
    let result = "" + parseInt(secondTime) + "秒";
    if (minuteTime > 0) {result = "" + parseInt(minuteTime) + "分" + result;}
    if (hourTime > 0) {result = "" + parseInt(hourTime) + "小时" + result;}
    return result;
  }else if(courseType==='LIVE_VOICE' || courseType==='LIVE_IMAGE_TEXT' || courseType==='LIVE_EDUCATION' || courseType==='LIVE_INTERACTIVE_VIDEO'){
    return duration+'分钟'
  }
}

// 课程 类型 class 名
// export function knowledgeTypeClass(type) {
//   // console.log(type)
//   if(type==='VIDEO'){ // 视频
//     return 'type-1'
//   }else if(type==='AUDIO'){ // 音频
//     return 'type-2'
//   }else if(type==='LIVE_VOICE' || type==='LIVE_IMAGE_TEXT' || type==='LIVE_EDUCATION' || type==='LIVE_INTERACTIVE_VIDEO'){ // 直播
//     return 'type-3'
//   }else if(type===null){ // 专题
//     return 'type-4'
//   }else {
//     return ''
//   }
// }

// 课程 类型 class 名
export function knowledgeTypeName(type) {
  // console.log(type)
  if(type==='VIDEO'){ // 视频
    return '视频'
  }else if(type==='AUDIO'){ // 音频
    return '音频'
  }else if(type==='LIVE_VOICE' || type==='LIVE_IMAGE_TEXT' || type==='LIVE_EDUCATION' || type==='LIVE_INTERACTIVE_VIDEO'){ // 直播
    return '直播'
  }else if(type===null){ // 专栏
    return '专栏'
  }else {
    console.log('未知 type: ' + type)
    return ''
  }
}



export function appDownload(query) {
  let req = '';
  if(query){
    if(query.inviteCode){
      req = '?inviteCode='+query.inviteCode + '&t=' + Date.now();
    }else if(query.inviteUserId){
      req = '?inviteUserId='+query.inviteUserId + '&t=' + Date.now();
    }
  }
  let url = local('origin') + '/h5/register' + req;
  console.log( url );
  Dialog.confirm({
    title: '提示',
    message: '此功能请在APP中使用，是否前往下载？'
  }).then(() => {
    window.location.href = url;
  }).catch(() => {});
}


export function showImagePreview(obj) { // { images, startPosition }
  let { images, startPosition } = Object.assign({}, obj)
  startPosition = (!startPosition)? 0: startPosition;
  ImagePreview({images,startPosition})
}

export function $math(f, digit) {
  let m = Math.pow(10, digit);
  return parseInt(f * m, 10) / m;
}




/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 *
 * @param num1加数1 | num2加数2
 */
export function $numAdd(num1, num2) {
  let baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}



/**
 * 加法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * @param num1被减数  |  num2减数
 */
export function $numSub(num1, num2) {
  let baseNum, baseNum1, baseNum2;
  let precision;// 精度
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
}



/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 *
 * @param num1被乘数 | num2乘数
 */
export function $numMulti(num1, num2) {
  let baseNum = 0;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {
  }
  return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
}



/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 *
 * @param num1被除数 | num2除数
 */
export function $numDiv(num1, num2) {
  let baseNum1 = 0, baseNum2 = 0;
  let baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  // with (Math) {
  //   baseNum3 = Number(num1.toString().replace(".", ""));
  //   baseNum4 = Number(num2.toString().replace(".", ""));
  //   return (baseNum3 / baseNum4) * pow(10, baseNum2 - baseNum1);
  // }

  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
}

// 检查是否存在七牛链接
export function checkQiNiuUrl(url) {
  if (url) {
    if (/^(http|https):\/\//.test(url)) {
      return url
    } else {
      let fileServerDomain = (session('user') && session('user').fileServerDomain) || ''
      return ( fileServerDomain || 'https://fileqn.anttalk.vip/') + url
    }
  } else {
    return url
  }
}

// http替换为https
export function replaceHttp2Https(url) {
  let str = url;
  if(str.indexOf("https:") < 0){
    str = str.replace("http:", "https:")
  }
  return str
}

//生成从minNum到maxNum的随机数
export function randomNum(minNum,maxNum){
  switch(arguments.length){
    case 1:
      return parseInt(Math.random()*minNum+1,10);
      break;
    case 2:
      return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
      break;
    default:
      return 0;
      break;
  }
}

// 防抖函数
export function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
// 节流函数
export function throttle(func, wait) {
  let timeout;
  let lastTime = 0;
  return function() {
    const context = this;
    const args = arguments;
    const now = Date.now();
    if (now - lastTime > wait) {
      if (timeout) clearTimeout(timeout);
      func.apply(context, args);
      lastTime = now;
    } else if (!timeout) {
      timeout = setTimeout(() => {
        func.apply(context, args);
        lastTime = Date.now();
      }, wait);
    }
  };
}
